import type { Commitment, RpcResponseAndContext, SignatureResult } from '@solana/web3.js'
import { useCallback } from 'react'

import { toResultAsync } from '@/utils/helpers'
import { useConnection } from '@/wallet/adapter'

const isCommitment = (value: unknown): value is Commitment => typeof value === 'string'

const useConfirmTransaction = () => {
  const { connection } = useConnection()

  const confirmTransaction = useCallback(
    async (
      txSignature: string,
      commitmentOrLatestBlockhash:
        | Commitment
        | {
            blockhash: string
            lastValidBlockHeight: number
          } = 'finalized',
    ) => {
      const latestBlockhash =
        isCommitment(commitmentOrLatestBlockhash)
          ? await connection.getLatestBlockhash(commitmentOrLatestBlockhash)
          : commitmentOrLatestBlockhash

      const [, confirmation] = await toResultAsync(
        connection.confirmTransaction({
          signature: txSignature,
          ...latestBlockhash,
        }),
      )
      const error = !confirmation || confirmation.value.err

      return [error, confirmation] as [boolean, RpcResponseAndContext<SignatureResult>]
    },
    [connection],
  )

  return { confirmTransaction }
}

export default useConfirmTransaction
